import React, {useContext, useState} from 'react';
import {Link} from 'react-router-dom';

const RenderNav = ({CategoryName, org_id, cat_id, status, org_rol_s, confirmAction}) => (
  <nav aria-label='breadcrumbs' className='breadcrumb_format_degreeofferred'>
    <ol data-cb-apricot='breadcrumb'>
      <li>
        <span style={{width: "100%"}}>
          <Link 
            state={{
              CategoryName,
              org_id,
              cat_id,
              status,
              org_rol_s
            }}
            to="#" 
            id='homeclick _degreeofferred' 
            onClick={() => confirmAction('/')}
            style={{color:'white'}}
          >
              Home
          </Link>
        </span>
      </li>
      <li style={{color:'white'}}> / </li>
      <li>
        <span style={{width: "100%"}}>
          <Link 
            state={{
              CategoryName,
              org_id,
              cat_id,
              status,
              org_rol_s
            }}
            to="#" 
            id='categoryclick_degreeofferred'  
            onClick={()=>confirmAction(`organizations/${org_id}/categories/${0}/${org_rol_s}`)}
            style={{color:'white'}}
          >
              Categories
          </Link>
        </span>
      </li>
      <li style={{color:'white'}}>/ </li>
      <li style={{color:'white'}}>
        <span>
        Modules
        </span>
      </li>
    </ol>
  </nav>
);

export default RenderNav;